import { useCallback, useEffect, useState } from 'react'

const STORAGE_KEY = 'madou-favorites'
const CHANGE_EVENT = 'madou-favorites-change'

function readFavorites(): string[] {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY)
    if (!raw) return []
    const parsed = JSON.parse(raw)
    if (!Array.isArray(parsed)) return []
    return parsed.filter((item): item is string => typeof item === 'string')
  } catch {
    return []
  }
}

function writeFavorites(ids: string[]) {
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(ids))
  } catch {
    // 本地存储不可用时静默降级，页面依然可用
  }
  window.dispatchEvent(new Event(CHANGE_EVENT))
}

export function useFavorites() {
  const [favorites, setFavorites] = useState<string[]>(() => readFavorites())

  useEffect(() => {
    const sync = () => setFavorites(readFavorites())
    window.addEventListener(CHANGE_EVENT, sync)
    window.addEventListener('storage', sync)
    return () => {
      window.removeEventListener(CHANGE_EVENT, sync)
      window.removeEventListener('storage', sync)
    }
  }, [])

  const toggleFavorite = useCallback((id: string) => {
    const current = readFavorites()
    const next = current.includes(id)
      ? current.filter((item) => item !== id)
      : [...current, id]
    writeFavorites(next)
  }, [])

  const isFavorite = useCallback((id: string) => favorites.includes(id), [favorites])

  return { favorites, toggleFavorite, isFavorite }
}